import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import _, { get } from 'lodash'

import styled from 'styled-components'
import { Button, Form, FormGroup, Label, Input, Container, Row, Col } from 'reactstrap'
import { authSelector } from './../../selectors'
import { authAction } from './../../actions/'
import withLayout from '../../helpers/withLayout'
import Modal from '../../components/modal'

class ChangePassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      valid: true,
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
  }
  componentDidMount() {
    this.props.getAuth(localStorage.getItem('access_token'))
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'authChangePassword.status') === 200) {
      localStorage.clear()
      window.location = '/'
    }
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  submitForm() {
    if (this.state.newPassword !== this.state.confirmNewPassword) {
      this.setState({ valid: false })
    } else {
      this.setState({ valid: true })
      this.props.changePassword(
        {
          // email: this.state.email,
          oldPassword: this.state.oldPassword,
          newPassword: this.state.newPassword,
        }, localStorage.getItem('access_token'))
    }
  }
  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    return (
      <DataCon fluid>
        <DataRow>
          <ColPass>
            <FormStyle>
              {
                get(this.props, 'authChangePassword.authChangePassword') &&
                  <Modal reset={ this.props.resetChangePassword } type={ _.get(this.props, 'authChangePassword.status') } message={ _.get(this.props, 'authChangePassword.message') } />
              }
              <FormGroup>
                <RowField>
                  <Col md="5" ><LabelStyle >Old Password</LabelStyle></Col>
                  <Col><Input name="oldPassword" placeholder="" type="password" value={ this.state.oldPassword } onChange={ this.handleInput } />
                  </Col>
                </RowField>
              </FormGroup>
              <FormGroup>
                <RowField>
                  <Col md="5"><LabelStyle >New Password</LabelStyle></Col>
                  <Col><Input name="newPassword" placeholder="" type="password" value={ this.state.newPassword } onChange={ this.handleInput } />
                  </Col>
                </RowField>
              </FormGroup>
              <FormGroup>
                <RowField>
                  <Col md="5"><LabelStyle >Confirm New Password</LabelStyle></Col>
                  <Col><Input invalid={ !this.state.valid } name="confirmNewPassword" placeholder="" type="password" value={ this.state.confirmNewPassword } onChange={ this.handleInput } />
                    { !this.state.valid && <p style={ { color: 'red' } }>Confirm password does not match</p> }
                  </Col>
                </RowField>
              </FormGroup>
              <SubmitBtn onClick={ this.submitForm }>Change Password</SubmitBtn>
            </FormStyle>
          </ColPass>
        </DataRow>
      </DataCon>
    )
  }
}

ChangePassword.propTypes = {
  changePassword: PropTypes.func.isRequired,
  resetChangePassword: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  redirectAuth: authSelector.redirectAuth,
  authChangePassword: authSelector.getChangePasswordData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  changePassword: authAction.changePassword,
  resetChangePassword: authAction.resetChangePassword,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(ChangePassword))

const DataCon = styled(Container)`
    height: 100% ;
    padding: 0% ;
    width: 100%;
`
const DataRow = styled(Row)`
    height: 100% ;
    width: calc(100vw - 800px) ;
    padding-left: 3%;
    @media (max-width: 575.98px) {
      width: 100%;
    }
`
const RowField = styled(Row)`
    margin-bottom: 5%;
`
const SubmitBtn = styled(Button)`
    float:right;
    width: 240px;
    height: 40px;
    background-color: #428BCA;
    border: 1px solid #428BCA;
    border-radius: 4px ;
    margin-top: 5%;
`
const FormStyle = styled(Form)`
    padding: 8%;
`
const LabelStyle = styled(Label)`
    color: #000;
    font-size: 14px ;
    padding-top: 5%;
`
const ColPass = styled(Col)`
    height : 75% ;
    margin: 3% ;
    font-family: 'Gotham' !important;
    font-size: 14px ;
    color: #428BCA;
    background-color: #FFFFFF ;
    -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
    -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
    box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`



// WEBPACK FOOTER //
// ./src/pages/change-password/index.js